import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, version2 } from 'ui-components/components/input';
import { useFulfillmentPlannerContext } from '../context';
import { ValidationMessage } from './validation-message';
import { ReadOnlyMessageForMultiPackageConfigs } from './read-only-message-for-multi-package-configs';

export const MAX_CHAR_COUNT = 35;

const PackageContentDescriptionInput = ({ id = 'package-content-description-input', inputClassName, readOnlyMessageClassName }) => {
  // Conceptually we want to initialize this with the 'value from the shippingConfiguration'
  // and because this contentDescription lives on the shippingConfiguration.packages[0] object,
  // we grab that value here. Crucially this only supports single package configurations, so multi-package
  // and/or bulk updates will rely on a different component/context interaction than this one.
  const { onContentDescriptionChange, packages } = useFulfillmentPlannerContext();
  const [inputValue, setInputValue] = useState(packages?.[0]?.contentDescription ?? '');

  const [isTouched, setIsTouched] = useState(false);

  const handleChange = useCallback(({ target }) => {
    const { value } = target;
    setInputValue(value);
    setIsTouched(true);
  }, []);

  const handleBlur = useCallback(() => {
    onContentDescriptionChange(inputValue);
    setIsTouched(true);
  }, [inputValue, onContentDescriptionChange]);

  const isMultiPackage = packages?.length > 1;
  if (isMultiPackage) {
    return <ReadOnlyMessageForMultiPackageConfigs className={readOnlyMessageClassName} />;
  }

  return (
    <Input
      className={inputClassName}
      // hasError - TODO: Add support for this
      id={id}
      inlineMessage={
        <ValidationMessage
          remainingCount={MAX_CHAR_COUNT - inputValue.length}
          showCount={isTouched}
          showError={isTouched && !inputValue.length}
        />
      }
      maxLength={MAX_CHAR_COUNT}
      onBlur={handleBlur}
      onChange={handleChange}
      value={inputValue}
      version={version2}
    />
  );
};

PackageContentDescriptionInput.propTypes = {
  id: PropTypes.string,
  inputClassName: PropTypes.string,
  readOnlyMessageClassName: PropTypes.string,
};

export { PackageContentDescriptionInput };
